/**
 * AVA Design System — EmptyState
 *
 * Card dashed con icono + título + body + CTA opcional.
 * Para listados vacíos: "Sin empresas", "Sin casos asignados", "Sin alertas".
 *
 * Estilo alineado al kit v2: fondo blanco, border dashed sutil,
 * ícono "flotante" sin contenedor circular destacado.
 */
import type { ReactNode } from "react";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  /** Acepta ReactNode para permitir énfasis (<strong>) en lugar de comillas literales. */
  body?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  body,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={`rounded-xl text-center border border-dashed ${className ?? ""}`}
      style={{
        padding: "clamp(28px, 6vw, 56px) 20px",
        background: "#ffffff",
        borderColor: "var(--ava-neutral-200, #e2e8f0)",
      }}
    >
      <p className="m-0 text-[15px] font-semibold text-foreground">{title}</p>
      {body && (
        <p className="text-xs text-muted-foreground mt-1.5 mx-auto max-w-md leading-relaxed">
          {body}
        </p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 inline-flex items-center gap-2 px-4 rounded-lg bg-primary text-primary-foreground font-medium text-sm hover:opacity-90 transition-opacity"
          style={{ height: "var(--ava-control-h-lg, 44px)" }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
